 class GraphDashboardRCS {
  constructor(data) {
    this.data = data;
  }

  getLabelsAxisHour() {
    const data = this.data;
    const labels = [...new Set(data.map((item) => item.i_hour))];

    return labels;
  }

  getLabelsAxisX() {
    const labels = this.getLabelsAxisHour();

    const labelwithInfo = labels.map(
      (label) => `${String(label).padStart(2, "0")}:00`
    );
    return labelwithInfo;
  }

  getAxisYSendData() {
    const data = this.data;
    const sendData = data.map((item) => item.i_send);
    return sendData;
  }

  getAxisYResponseData() {
    const data = this.data;
    const responseData = data.map((item) => item.i_deliver);
    return responseData;
  }
}

export default GraphDashboardRCS;
